import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export const getPlacingForImpactTracker = (defaultLocation: string) => {
  if (!isBrowser()) return defaultLocation
  const currentPagePath = window.location.pathname
  if (currentPagePath === '/quince-offers') return 'Deal_Page'
  return defaultLocation
}
